
import { TranslationService } from "@/core/services/TranslationService";
import { FormatMethods } from "@/helpers/data-format";
import { IUser } from "@/interfaces/iUser";
import VZKeyValue from "@/components/content/VZKeyValue.vue";
import { computed, defineComponent, PropType, ref, toRefs } from "vue";
import UserPhoneModal from "@/components/modals/forms/UserPhoneModal.vue";
export default defineComponent({
  name: "user-detail",
  inheritAttrs: false,
  components: { VZKeyValue, "vz-user-phone-modal": UserPhoneModal },
  props: {
    data: { type: Object as PropType<IUser>, required: true },
    showCard: { type: Boolean, required: false, default: true },
  },
  setup(props) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };

    const showPhoneDialog = ref<any>(false);

    const { data } = toRefs(props);

    const format = computed(() => {
      return FormatMethods;
    });
    const items = computed(() => {
      return [
        {
          header: t("common.firstName"),
          value: data.value.firstName,
        },
        {
          header: t("common.lastName"),
          value: data.value.lastName,
        },
        {
          header: t("common.email"),
          value: data.value.email,
        },
        {
          header: t("pages.user.phoneNumber"),
          value: format.value.formatPhoneNumber(data.value.phoneNumber),
          slot: "phoneNumber",
        },
        {
          header: t("common.startDate"),
          value: data.value.startDate
            ? format.value.convertUTCToLocalDate(data.value.startDate)
            : "",
        },
        {
          header: t("common.endDate"),
          value: data.value.endDate
            ? format.value.convertUTCToLocalDate(data.value.endDate)
            : "",
        },
        {
          header: t("pages.user.birthday"),
          value: data.value.birthday
            ? format.value.convertUTCToLocalDate(data.value.birthday)
            : "",
        },
        {
          header: t("common.status"),
          value: data.value.status
            ? format.value.TitleCase(data.value.status?.toLowerCase())
            : "",
          valueClass:
            data.value.status?.toLowerCase() === "active"
              ? "badge badge-success bg-success"
              : "badge badge-danger bg-danger",
        },
        {
          header: t("common.createdDate"),
          value: data.value.createdDate
            ? format.value.convertUTCToLocalDate(
                data.value.createdDate,
                "MM-DD-YYYY hh:mm A"
              )
            : "",
        },
        {
          header: t("common.createdBy"),
          value: data.value.createdBy,
        },
        {
          header: t("common.updatedDate"),
          value: data.value.updateDate
            ? format.value.convertUTCToLocalDate(
                data.value.updateDate,
                "MM-DD-YYYY hh:mm A"
              )
            : "",
        },
        {
          header: t("common.updatedBy"),
          value: data.value.updatedBy,
        },
      ];
    });

    return {
      t,
      format,
      items,
      showPhoneDialog,
    };
  },
});
